<template>
  <a-table :columns="columns" :data-source="schedule">
    <div slot="startTimeRender" slot-scope="text">
      {{ nTime(text) }}
    </div>
    <div slot="sessionLength" slot-scope="text">
      {{ floatToHour(text) }} Hours
    </div>
    <div slot="dob" slot-scope="text">
      {{ nFormat(text) }}
    </div>
    <div slot="created_at" slot-scope="text">
      {{ nFormat(text) }}
    </div>
    <div slot="phone" slot-scope="text">
      <template v-if="text">+353 {{ text }}</template>
      <template v-else>N/A</template>
    </div>
    <div slot="status" slot-scope="text">
      <a-tag v-if="text === 'accepted'" color="#27ae60">Active</a-tag>
      <a-tag v-if="text === 'invited'" color="#f39c12">Invite Pending</a-tag>
      <a-tag v-if="text === 'requested'" color="#d35400"
        >Pending Club Acceptance</a-tag
      >
      <a-tag v-if="text === 'archived'" color="#d35400"
        >No Longer a Member</a-tag
      >
      <a-tag v-if="text === 'declined'" color="#c0392b"
        >Declined Invitation</a-tag
      >
    </div>
    <div slot="handlers" slot-scope="text, record" class="gx-text-right">
      <a-button
        v-if="record.status === 'requested'"
        size="small"
        type="danger"
        style="margin-bottom:0; margin-left:5px;"
        @click="userTableList(record.id, record.id, 'archived', record.cmId)"
      >
        Cancel Join Request
      </a-button>
      <a-button
        v-if="record.status === 'accepted'"
        size="small"
        type="danger"
        style="margin-bottom:0; margin-left:5px;"
        @click="userTableList(record.id, record.id, 'archived', record.cmId)"
      >
        Leave Club
      </a-button>
      <a-button
        v-if="record.status === 'invited'"
        size="small"
        type="danger"
        class="gx-btn-cyan"
        style="margin-bottom:0; margin-left:5px;"
        @click="userTableList(record.id, record.id, 'accepted', record.cmId)"
      >
        Accept Invite
      </a-button>
      <a-button
        v-if="record.status === 'invited'"
        size="small"
        class="gx-btn-red"
        style="margin-bottom:0; margin-left:5px;"
        @click="userTableList(record.id, record.id, 'declined', record.cmId)"
      >
        Decline Invite
      </a-button>
    </div>
  </a-table>
</template>

<script>
import nTime from "@/mixins/time";
import nCurrency from "@/mixins/currency";
// import notifications from "@/common/notifications/notification.service";
import { memberService } from "@/common/api/api.service";
const columns = [
  {
    title: "Club",
    dataIndex: "club_name",
    key: "club_name",
    sorter: (a, b) => {
      if (a.club_name < b.club_name) {
        return -1;
      }
      if (a.club_name > b.club_name) {
        return 1;
      }
      return 0;
    }
  },
  {
    title: "Email",
    dataIndex: "club_email",
    key: "club_email"
  },
  {
    title: "Phone",
    dataIndex: "club_phone",
    key: "club_phone"
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    scopedSlots: {
      customRender: "status"
    }
  },
  {
    dataIndex: "handlers",
    key: "handlers",
    scopedSlots: {
      customRender: "handlers"
    }
  }
];

export default {
  name: "MyClubsTable",
  mixins: [nTime, nCurrency],
  props: {
    memberId: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      columns,
      schedule: []
    };
  },
  mounted() {
    this.getTeamSchedule();
  },
  methods: {
    userTableList(memberId, inviteId, status, cmID) {
      memberService
        .UserTablelist(memberId, {
          status: status,
          inviteId: inviteId,
          cmID: cmID
        })
        .then(resp => {
          if (resp.data.success) {
            this.getTeamSchedule();
          }
        });
    },
    getTeamSchedule() {
      if (this.memberId)
        memberService
          .query({
            status: "all",
            memberId: this.memberId
          })
          .then(resp => {
            if (resp.data.success) {
              this.schedule = resp.data.result;
            }
          });
    }
  }
};
</script>
